import { forwardRef, createElement } from 'react';

function IconPlusMinus(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M6.169 17.055c.43 0 .734-.305.734-.75V13.43h2.649c.453 0 .757-.297.757-.72 0-.429-.304-.726-.757-.726H6.903V9.258c0-.445-.304-.758-.734-.758s-.727.313-.727.758v2.726H2.825c-.445 0-.758.297-.758.727 0 .422.313.719.758.719h2.617v2.875c0 .445.305.75.727.75zm5.598 2.453c.352 0 .64-.211.735-.555l3.453-12.25a1.17 1.17 0 00.047-.258c.007-.406-.336-.75-.766-.75-.36 0-.648.211-.742.547l-3.446 12.25a.749.749 0 00.719 1.016zm9.388-6.11c.578 0 .882-.32.882-.78 0-.462-.304-.766-.882-.766h-3.68c-.57 0-.883.312-.883.765 0 .461.305.781.883.781h3.68z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var PlusMinus = /*#__PURE__*/forwardRef(IconPlusMinus);

export default PlusMinus;
//# sourceMappingURL=PlusMinus.js.map
